export const carReferenceModelFeatureKey = 'carReferenceModel';

export type CarReferenceModelModel = {
  id: number;
  name: string;
  carReferenceBrandId: number;
  carReferenceBrandName: string;
};
